import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as pendingProductsForSomeoneElseState from '../employee-detail.reducer';
import * as pendingProductsForSomeoneElseReducer from '../reducers/pending-products-for-someone-else.reducer';

export const getPendingProductsForSomeoneElse = createSelector(
  pendingProductsForSomeoneElseState.getPendingProductsForSomeoneElseState,
  pendingProductsForSomeoneElseReducer.getPendingProductsForSomeoneElseResponse
);
